<template>
  <div style="height: 100%;background-color: white">
    <div style="height: 20px"></div>
    <div style="margin: 0 20px">
      <div style="height: 50px">
        <div style="float: left">
          <el-date-picker v-fixZoom
            v-model="voiceDate"
            type="daterange"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd"
            style="width: 400px"
            :clearable="false">
          </el-date-picker>
          <el-input
            prefix-icon="el-icon-search"
            placeholder="输入标题搜索"
            v-model="searchKeyword"
            style="width: 300px"
            @blur="blurSearch()">
          </el-input>
          <el-button type="success" @click="getVoiceTableData()">查询</el-button>
        </div>
        <div style="float: right">
          <el-button type="success" @click="openVoice()">批量语音通知</el-button>
        </div>
        <div style="clear:both;"></div>
      </div>
      <div style="max-height: calc(100% - 100px);overflow-y: auto;">
        <el-table
          v-loading="loading"
          element-loading-text="加载中，请耐心等待。"
          :data="showTable"
          border
          style="width: 100%;margin-top: 10px"
          highlight-current-row>
          <el-table-column
            type="index"
            label="序号"
            width="50"
            align="center">
          </el-table-column>
          <el-table-column
            prop="title"
            label="标题"
            min-width="110"
            align="center">
          </el-table-column>
          <el-table-column
            prop="text"
            label="通知内容"
            min-width="180"
            align="center">
          </el-table-column>
          <el-table-column
            prop="create_tm"
            label="通知时间"
            min-width="140"
            align="center">
          </el-table-column>
          <el-table-column
            prop="orgname"
            label="通知对象"
            min-width="90"
            align="center">
          </el-table-column>
          <el-table-column
            prop="sendcount"
            label="发送数量"
            min-width="80"
            align="center">
          </el-table-column>
          <el-table-column
            prop="readcount"
            label="已读数量"
            min-width="80"
            align="center">
          </el-table-column>
          <el-table-column
            label="已读状态"
            min-width="70"
            align="center">
            <template slot-scope="scope">
              {{getIsread(scope.row)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="username"
            label="发送人"
            min-width="90"
            align="center">
          </el-table-column>
          <el-table-column align="center" label="操作" width="130">
            <template slot-scope="scope">
              <i title="详情" class="el-icon-view" style="cursor: pointer; font-size: 18px;color: blue" @click="openShowDetails(scope.row)"></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="margin-top: 10px;height: 40px;text-align: center">
        <el-pagination v-fixZoom
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCells">
        </el-pagination>
      </div>
    </div>
    <!--詳情-->
    <el-dialog
      :title="detailsTitle"
      :visible.sync="openDetails"
      v-if="openDetails"
      width="950px"
      :show-close="true"
      :close-on-click-modal="false"
      center
      top="10vh">
      <voice-details :voiceObj="voiceObj" v-model="openDetails"></voice-details>
    </el-dialog>
    <!--批量语音通知-->
    <el-dialog
      :visible.sync="voiceShow"
      v-if="voiceShow"
      width="650px"
      :show-close="true"
      :close-on-click-modal="false"
      class="all-open">
      <div class="title-top-alarm">
        <div>
          <span>批量语音通知</span>
        </div>
        <div class="line-title"></div>
      </div>
      <voice-open-show :device="voiceObj1" v-model="voiceShow" @getFatherVoice="getFatherVoice"></voice-open-show>
    </el-dialog>
  </div>
</template>

<script>
import {queryvoicemessagebylevel, searchvoicemessage} from '../../../api/voice'
// import {queryorg} from '../../../api/organizer'
import voiceDetails from '../childComponents/voiceDetails'
import voiceOpenShow from '../childComponents/voiceOpenShow'
export default {
  name: 'voiceOrg',
  components: {voiceDetails, voiceOpenShow},
  data () {
    return {
      orgObj: '',
      searchKeyword: '',
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      showTable: [],
      tableData: [],
      loading: false,
      voiceDate: [],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        },
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      detailsTitle: '',
      openDetails: false,
      voiceObj: {
        voiceRow: '',
        isDevice: false
      },
      voiceShow: false,
      voiceObj1: {
        isOrgVoice: true,
        device: '',
        org: [],
        community: [],
        home: [],
        push_type: 1,
        orgObj: ''
      }
    }
  },
  created () {
    this.fun_date()
    // this.getOrgData()
    // this.getVoiceTable()
  },
  methods: {
    getVoice (obj) {
      console.log(obj)
      this.orgObj = obj.orgObj
      this.voiceObj1.org = obj.orgData
      this.voiceObj1.orgObj = obj.orgObj
      this.getVoiceTable()
    },
    fun_date () {
      // eslint-disable-next-line no-extend-native
      Date.prototype.format = this.validate.format
      let time = new Date().getTime()
      time -= 86400000 * 6
      let aa = new Date(time).format('yyyy-MM-dd')
      const date = new Date().format('yyyy-MM-dd')
      this.voiceDate = [aa, date]
    },
    blurSearch () {
      if (this.searchKeyword === '') {
        this.currentPage = 1
        this.pageSize = 10
        this.getVoiceTable()
      }
    },
    // 组织
    // getOrgData () {
    //   queryorg().then(res => {
    //     this.voiceObj1.org = res.data.org
    //   }).catch(() => {})
    // },
    getVoiceTableData () {
      this.currentPage = 1
      this.pageSize = 10
      if (this.searchKeyword === '') {
        this.getVoiceTable()
      } else {
        this.getSearchVoice()
      }
    },
    getSearchVoice () {
      let data = {
        from: this.voiceDate[0] + ' 00:00:00',
        to: this.voiceDate[1] + ' 23:59:59',
        title: this.searchKeyword
      }
      let params = {
        page: this.currentPage,
        size: this.pageSize
      }
      searchvoicemessage(data, params).then(res => {
        this.totalCells = res.data.cnt
        this.showTable = res.data.voicemessages
        this.loading = false
      }).catch(() => {})
    },
    getVoiceTable () {
      this.loading = true
      let data = {
        mqttlevel: this.orgObj.mqttlevel,
        from: this.voiceDate[0] + ' 00:00:00',
        to: this.voiceDate[1] + ' 23:59:59'
      }
      let params = {
        page: this.currentPage,
        size: this.pageSize
      }
      queryvoicemessagebylevel(data, params).then(res => {
        this.totalCells = res.data.cnt
        this.showTable = res.data.voicemessages
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    getFatherVoice () {
      if (this.searchKeyword === '') {
        this.getVoiceTable()
      } else {
        this.getSearchVoice()
      }
    },
    handleSizeChange (val) {
      this.pageSize = val
      if (this.searchKeyword === '') {
        this.getVoiceTable()
      } else {
        this.getSearchVoice()
      }
    },
    handleCurrentChange (val) {
      this.currentPage = val
      if (this.searchKeyword === '') {
        this.getVoiceTable()
      } else {
        this.getSearchVoice()
      }
    },
    getIsread (row) {
      return row.readcount / row.sendcount * 100 + '%'
    },
    openShowDetails (row) {
      this.voiceObj.voiceRow = row
      this.detailsTitle = '【' + row.title + '】详情'
      this.openDetails = true
    },
    openVoice () {
      this.voiceShow = true
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/deviceComponents/voiceOrg.vue